import Vue from "vue";
import App from "./App";
import router from "./router";
import ElementUI from "element-ui";
import i18n from "@/utils/i18n";

import { i18n as elementI18n } from 'element-ui/lib/locale';
import { Uploader, Overlay, Notify } from "vant";

import VueAwesomeSwiper from "vue-awesome-swiper";
import lodash from "lodash";

import "babel-polyfill";
import "vant/lib/index.css";
import "normalize.css/normalize.css";
import "element-ui/lib/theme-chalk/index.css";

// global css
import "@/styles/index.scss";
import "./common/font/font.css";

elementI18n(i18n);

Vue.use(ElementUI, {
  i18n: (key, value) => i18n.t(key, value)
});
Vue.use(Uploader);
Vue.use(Overlay);
Vue.use(Notify);
Vue.use(VueAwesomeSwiper);

Vue.prototype.$lodash = lodash;

// Vue.config.productionTip = false
// import store from './store';

// 图片地址
Vue.prototype.oAssets = process.env.BASE_IMG;

// 本地
// Vue.prototype.oAssets = './src/assets/mobile'

new Vue({
  el: "#app",
  i18n,
  router,
  template: "<App/>",
  components: {
    App
  }
});



// WEBPACK FOOTER //
// ./src/main.js